const documentTypes = ['PRESENTATION', 'FINANCIAL', 'PRODUCT AND TECH', 'LEGAL', 'RESEARCH']

export default documentTypes
